import { DELIVERY_DAYS } from "../config/deliveryConfig";

const allowedDaysMap = {
  0: DELIVERY_DAYS.sunday,
  1: DELIVERY_DAYS.monday,
  2: DELIVERY_DAYS.tuesday,
  3: DELIVERY_DAYS.wednesday,
  4: DELIVERY_DAYS.thursday,
  5: DELIVERY_DAYS.friday,
  6: DELIVERY_DAYS.saturday,
};

export function isDateAllowed(date) {
  const day = date.getDay();
  return Boolean(allowedDaysMap[day]);
}

export function parseDateInputValue(value) {
  if (!value) {
    return null;
  }

  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) {
    return null;
  }

  return new Date(year, month - 1, day);
}

export function toDateInputValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getTomorrowDate() {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 1);
  return date;
}

export function getNextAllowedDate(startDate = getTomorrowDate()) {
  const date = new Date(startDate);
  date.setHours(0, 0, 0, 0);

  for (let index = 0; index < 14; index += 1) {
    if (isDateAllowed(date)) {
      return date;
    }
    date.setDate(date.getDate() + 1);
  }

  return startDate;
}

export function isBeforeDay(date, minDate) {
  const current = new Date(date);
  const minimum = new Date(minDate);
  current.setHours(0, 0, 0, 0);
  minimum.setHours(0, 0, 0, 0);
  return current < minimum;
}
